import { render, staticRenderFns } from "./orderPoolTable.vue?vue&type=template&id=09b70532&scoped=true"
import script from "./orderPoolTable.vue?vue&type=script&lang=js"
export * from "./orderPoolTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09b70532",
  null
  
)

export default component.exports